import {createPolyline, IPolyline, IPolylinePresetName} from "@pg-mono/open-street-map";

import {IPublicTransportRouteWithStops} from "../types/IPublicTransportRouteWithStops";
import {IPublicTransportType} from "../types/IPublicTransportType";

export function getMapTransportPolyline(transportRoute: IPublicTransportRouteWithStops) {
    const type = transportRoute.type;

    // Only the metro preset needs overriding (different, more visible color; solid instead of dashed) -
    // bus/tram/train already look right with the shared preset as-is, so we let those pass through untouched.
    const polyline: IPolyline = createPolyline(getPoiRoutePolylinePreset(type), {
        id: `public-transport-route_${transportRoute.id}`,
        positions: transportRoute.geometry?.coordinates || [],
        skipInFitBounds: true,
        ...(type === IPublicTransportType.SUBWAY ? {pathOptions: {color: "var(--colors-highlight)", weight: 4, dashArray: undefined, lineCap: undefined}} : {})
    });

    return polyline;
}

function getPoiRoutePolylinePreset(type?: IPublicTransportRouteWithStops["type"]): IPolylinePresetName {
    switch (type) {
        case IPublicTransportType.BUS:
            return "busLine";
        case IPublicTransportType.SUBWAY:
            return "subwayLine";
        case IPublicTransportType.TRAIN:
            return "trainLine";
        case IPublicTransportType.TRAM:
            return "tramLine";
        default:
            return "secondaryDashed";
    }
}
import {createPolyline, IPolyline, IPolylinePresetName} from "@pg-mono/open-street-map";

import {IPublicTransportRouteWithStops} from "../types/IPublicTransportRouteWithStops";
import {IPublicTransportType} from "../types/IPublicTransportType";

export function getMapTransportPolyline(transportRoute: IPublicTransportRouteWithStops) {
    const type = transportRoute.type;

    // Only the metro preset needs overriding (different, more visible color; solid instead of dashed) -
    // bus/tram/train already look right with the shared preset as-is, so we let those pass through untouched.
    const polyline: IPolyline = createPolyline(getPoiRoutePolylinePreset(type), {
        id: `public-transport-route_${transportRoute.id}`,
        positions: transportRoute.geometry?.coordinates || [],
        skipInFitBounds: true,
        ...(type === IPublicTransportType.SUBWAY ? {pathOptions: {color: "var(--colors-highlight)", weight: 4, dashArray: undefined, lineCap: undefined}} : {})
    });

    return polyline;
}

function getPoiRoutePolylinePreset(type?: IPublicTransportRouteWithStops["type"]): IPolylinePresetName {
    switch (type) {
        case IPublicTransportType.BUS:
            return "busLine";
        case IPublicTransportType.SUBWAY:
            return "subwayLine";
        case IPublicTransportType.TRAIN:
            return "trainLine";
        case IPublicTransportType.TRAM:
            return "tramLine";
        default:
            return "secondaryDashed";
    }
}
